var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24987 7.99982H3.66653M3.59599 8.24274L1.65022 14.055C1.49736 14.5116 1.42093 14.7399 1.47578 14.8805C1.52341 15.0026 1.62571 15.0952 1.75195 15.1304C1.89731 15.171 2.11687 15.0722 2.55598 14.8746L16.4822 8.60778C16.9108 8.4149 17.1251 8.31847 17.1913 8.1845C17.2489 8.06811 17.2489 7.93155 17.1913 7.81516C17.1251 7.68119 16.9108 7.58475 16.4822 7.39188L2.55112 1.12293C2.11334 0.925925 1.89444 0.827424 1.74922 0.867831C1.62311 0.902922 1.52082 0.995243 1.47302 1.11711C1.41798 1.25744 1.4936 1.48526 1.64482 1.94088L3.59653 7.8211C3.6225 7.89935 3.63549 7.93848 3.64062 7.9785C3.64517 8.01401 3.64512 8.04996 3.64048 8.08546C3.63525 8.12546 3.62216 8.16455 3.59599 8.24274Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c358f35fe929e8db785d3534bd8f56c6.svg";
export { ForwardRef as ReactComponent };